import { useT } from "../lib/i18n/store.js";

export interface NovelListPagination {
  hasMore: boolean;
  loadingMore: boolean;
  moreFailed: boolean;
  loadMore: () => Promise<void>;
  /** Load every remaining page — see useFullListForSort. */
  loadAll: () => Promise<void>;
}

export function NovelListMore({ pagination }: { pagination?: NovelListPagination }) {
  const t = useT();
  if (!pagination?.hasMore) return null;
  return <div className="page-section">
    {pagination.moreFailed && <p role="alert">{t("common.loadMoreFailed")}</p>}
    <button type="button" className="secondary" disabled={pagination.loadingMore}
      onClick={() => void pagination.loadMore()}>
      {pagination.loadingMore ? t("detail.loading") : t("common.loadMore")}
    </button>
  </div>;
}
